import React, { useEffect, useState } from "react";
import Reportselect from "./Reportselect";
import Select from "react-select";
import { format } from "date-fns";
import { Spinner } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { deptOptions } from "../../utilities";
import { genderdistributionreport } from "../../services/Reportservice";
import { searchshift } from "../../services/Reportservice";
import { searchroute } from "../../services/Reportservice";
import { PiExportBold } from "react-icons/pi";
import { genderdistributionreportdownload } from "../../services/Reportservice";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import { FaCalendarAlt } from "react-icons/fa";
import {
  addDays,
  subDays,
  startOfMonth,
  endOfMonth,
  subMonths,
} from "date-fns";
const Popularbusreport = () => {
  const [loading, setLoading] = useState(false);
  const [excellLoading, setExcellLoading] = useState(false);
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const defaultOption = { value: "7_days", label: "Last 7 Days" };
  const [selectedOption, setSelectedOption] = useState(defaultOption);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [routeoption, setRouteoption] = useState([]);
  const [shiftoption, setShiftoption] = useState([]);
  const [selecetdroute, setSelectedroute] = useState(null);
  const [selectedshift, setSelectedshift] = useState(null);
  const [selecteddepartment, setSelectetdepartment] = useState(null);
  const [param, setParam] = useState({
    start_date: format(subDays(new Date(), 7), "yyyy-MM-dd"),
    end_date: format(new Date(), "yyyy-MM-dd"),
    department: "",
    shift: "",
    route: "",
  });
  const getreport = () => {
    setLoading(true);
    genderdistributionreport(param)
      .then((res) => {
        setData(res?.data || []);
        setError("");
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getreport();
  }, [param]);
  useEffect(() => {
    searchshift()
      .then((res) => {
        setShiftoption(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
    searchroute()
      .then((res) => {
        setRouteoption(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  useEffect(() => {
    setParam({
      ...param,
      department: selecteddepartment?.value || "",
      shift: selectedshift?.value || "",
      route: selecetdroute?.value || "",
    });
  }, [selecetdroute, selectedshift, selecteddepartment]);
  const handleexport = () => {
    setExcellLoading(true);
    const newparam = { ...param, export: true };
    genderdistributionreportdownload(newparam)
      .then((res) => {
        const blob = new Blob([res.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "Genderdistribution-report.xlsx"; // set your desired filename
        a.click();

        window.URL.revokeObjectURL(url); // clean up
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setExcellLoading(false);
      });
  };
  const options = [
    { value: "yesterday", label: "Yesterday" },
    { value: "7_days", label: "Last 7 Days" },
    { value: "15_days", label: "Last 15 Days" },
    { value: "30_days", label: "Last 30 Days" },
    { value: "last_month", label: "Last Month" },
    { value: "3_months", label: "Last 3 Months" },
    { value: "custom", label: "Custom Date" },
  ];
  const handleSelectChange = (option) => {
    setSelectedOption(option);
    if (!option) {
      setParam({ ...param, start_date: "", end_date: "", page: "1" });
      return;
    }
    let startDate,
      endDate = new Date();
    switch (option.value) {
      case "yesterday":
        startDate = subDays(new Date(), 1);
        endDate = startDate;
        break;
      case "7_days":
        startDate = subDays(new Date(), 7);
        break;
      case "15_days":
        startDate = subDays(new Date(), 15);
        break;
      case "15_days":
        startDate = subDays(new Date(), 15);
        break;
      case "30_days":
        startDate = subDays(new Date(), 30);
        break;
      case "last_month":
        startDate = startOfMonth(subMonths(new Date(), 1));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "3_months":
        startDate = startOfMonth(subMonths(new Date(), 3));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "custom":
        setShowDatePicker(true);
        return;
      default:
        return;
    }
    setShowDatePicker(false);
    setParam({
      ...param,
      start_date: format(startDate, "yyyy-MM-dd"),
      end_date: format(endDate, "yyyy-MM-dd"),
      page: "1",
    });
  };
  return (
    <>
      <div className="row mb-3">
        <div className="col d-flex flex-column flex-md-row justify-content-between">
          <div>
            <span
              className="text-primary"
              style={{ fontSize: "1.3rem", fontWeight: "500" }}
            >
              Gender Distribution Report
            </span>
            <ol className="breadcrumb breadcrumb-arrow mb-0">
              <li className="breadcrumb-item">
                <Link to="/dashboard">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Report
              </li>
            </ol>
          </div>
          <div className="d-flex gap-2 justify-content-center align-items-center">
            <div style={{ width: "300px" }}>
              <Reportselect />
            </div>
            <button
              className="btn btn-primary d-flex align-items-center gap-1 align-self-center"
              onClick={handleexport}
              disabled={excellLoading || data.length === 0}
              // style={{ height: "38px" }}
            >
              {" "}
              {excellLoading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <PiExportBold size={18} />
              )}
              Export
            </button>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="d-flex justify-content-between flex-column flex-md-row gap-2 px-4 py-3">
          <div className="d-flex flex-column flex-md-row gap-3">
            <div className="flex-fill flex-md-grow-0">
              <small>Select Department</small>
              <Select
                className="react-select"
                classNamePrefix="select"
                options={deptOptions}
                value={selecteddepartment}
                onChange={setSelectetdepartment}
                isClearable
                placeholder="Select Department"
              />
            </div>
            <div
              className="flex-fill flex-md-grow-0 w-md-auto"
              style={{ maxWidth: "250px" }}
            >
              <small>Select Route</small>
              <Select
                className="react-select"
                classNamePrefix="select"
                options={routeoption}
                value={selecetdroute}
                onChange={setSelectedroute}
                isClearable
                placeholder="Select Route"
              />
            </div>
            <div className="flex-fill flex-md-grow-0">
              <small>Select Shift</small>
              <Select
                className="react-select"
                classNamePrefix="select"
                options={shiftoption}
                value={selectedshift}
                onChange={setSelectedshift}
                isClearable
                placeholder="Select Shift"
              />
            </div>
          </div>
          <div className="d-flex flex-column flex-md-row gap-2">
            {showDatePicker && (
              <div className="flex-fill flex-md-grow-0">
                <small>Select Date</small>
                {/* <DatePicker
              onChange={handleDateChange}
              autoHide={true}
              todayBtn={true}
              clearBtn={true}
              format="yyyy/mm/dd"
              value={{
                startDate: param.start_date,
                endDate: param.end_date,
              }}
            /> */}
                {/* <FaCalendarAlt className="me-2" /> */}
                <DatePicker
                  selectsRange
                  startDate={
                    param?.start_date ? new Date(param.start_date) : null
                  }
                  endDate={param?.end_date ? new Date(param.end_date) : null}
                  onChange={(update) => {
                    const [start, end] = update;
                    setParam((prev) => ({
                      ...prev,
                      start_date: start ? format(start, "yyyy-MM-dd") : "",
                      end_date: end ? format(end, "yyyy-MM-dd") : "",
                      page: 1,
                    }));
                  }}
                  isClearable
                  placeholderText="Select date range"
                  className="form-control"
                  style={{
                    fontSize: "0.5rem",
                  }}
                />
              </div>
            )}
            <div className="flex-fill flex-md-grow-0">
              <small>Select Period</small>
              <Select
                options={options}
                onChange={handleSelectChange}
                placeholder="Select Period"
                className="react-select"
                classNamePrefix="select"
                value={selectedOption}
              />
            </div>
          </div>
        </div>
        <div className="card-body p-0">
          <div className="table-responsive">
            {loading ? (
              <div className="text-center my-3">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : error ? (
              <div className="text-center text-danger my-3">{error}</div>
            ) : data && data?.length > 0 ? (
              <table class="table fs-6 mb-0 align-middle">
                <thead className="custom-thead table-light">
                  <tr>
                    <th>Gender</th>
                    <th>Count</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((row, index) => (
                    <tr key={index}>
                      <td>{row?.gender || "N/A"}</td>
                      <td>{row?.count || "N/A"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="my-2 text-center">
                There are no records found.
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Popularbusreport;
